import React from 'react';

/**
 * Technical grid background — engineering paper style.
 * Very low opacity, thin lines, large spacing.
 * Per design system: opacity 0.03–0.06, never visually dominant.
 */
const BackgroundPattern = () => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden text-text-primary dark:text-dark-text-primary">
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.04] dark:opacity-[0.05]"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        <defs>
          <pattern
            id="tech-grid"
            x="0"
            y="0"
            width="64"
            height="64"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 64 0 L 0 0 0 64"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#tech-grid)" />
      </svg>
    </div>
  );
};

export default BackgroundPattern;